import canUseDom from './dom';
import { ENDPOINTS } from 'config/api';
import { getJsonStr } from 'app/utilities/format';
import { url } from 'rfa-react-core';

const CMS_PAGE_DEPTH = 2;
const ENTITY_TYPE = {
    PAGE: 'page',
    EVENT: 'event',
    NEWS: 'news',
    PERFORMANCE: 'performance',
    VENUE: 'venue'
};

export const getSlug = (reqUrl) => {
    return url.getSlug(reqUrl);
};

export const getParent = (reqUrl) => {
    return url.getParent(reqUrl);
};

export const getEntityType = (reqUrl) => {
    const arr = reqUrl.split('/');
    const base = arr.length > CMS_PAGE_DEPTH ? arr[1] : '';

    switch (base) {
        case ENTITY_TYPE.EVENT:
            return ENTITY_TYPE.EVENT;
        case ENTITY_TYPE.NEWS:
            return ENTITY_TYPE.NEWS;
        case ENTITY_TYPE.PERFORMANCE:
            return ENTITY_TYPE.PERFORMANCE;
        case 'our-venues':
            return ENTITY_TYPE.VENUE;
        default:
            return ENTITY_TYPE.PAGE;
    }
};

export const getEndpoint = (entityType) => {
    switch (entityType) {
        case ENTITY_TYPE.EVENT:
            return ENDPOINTS.EVENTS;
        case ENTITY_TYPE.NEWS:
            return ENDPOINTS.NEWS;
        case ENTITY_TYPE.PERFORMANCE:
            return ENDPOINTS.PERFORMANCES;
        case ENTITY_TYPE.VENUE:
            return ENDPOINTS.VENUES;
        default:
            return ENDPOINTS.PAGES;
    }
};

export const getApiUrl = (reqUrl) => {
    return url.getApiUrl(reqUrl, getEntityType, getEndpoint);
};

export const getRouteArray = (reqUrl) => {
    return url.getRouteArray(reqUrl);
};

export const buildUrl = (path, params) => {
    const paramsString = Object.keys(params)
        .filter((param) => Boolean(params[param]))
        .map((param) => {
            return `${encodeURIComponent(param)}=${encodeURIComponent(params[param])}`;
        })
        .join('&');

    return `${path}${paramsString ? '?' : ''}${paramsString}`;
};

/**
 * `Entity` is one of the concepts from `CMS`, it looks like a `category` under every `project` inside `CMS`.
 *
 * @param {any} entityType
 */
const getEndpointArrByEntity = (entityType) => {
    const pageEndpoints = [{
        dataKey: 'page',
        endPoint: ENDPOINTS.PAGES,
        apiUrl: ''
    }];

    const eventEndpoints = [{
        dataKey: 'page',
        endPoint: ENDPOINTS.EVENTS,
        apiUrl: ''
    }];

    const newsEndpoints = [{
        dataKey: 'page',
        endPoint: ENDPOINTS.NEWS,
        apiUrl: ''
    }];

    const performanceEndpoints = [{
        dataKey: 'page',
        endPoint: ENDPOINTS.PERFORMANCES,
        apiUrl: ''
    }];

    const venueEndpoints = [{
        dataKey: 'page',
        endPoint: ENDPOINTS.VENUES,
        apiUrl: ''
    }];

    switch (entityType) {
        case ENTITY_TYPE.EVENT:
            return eventEndpoints;
        case ENTITY_TYPE.NEWS:
            return newsEndpoints;
        case ENTITY_TYPE.PERFORMANCE:
            return performanceEndpoints;
        case ENTITY_TYPE.VENUE:
            return venueEndpoints;
        default:
            return pageEndpoints;
    }
};

const getApiRequest = (reqUrl, entityTypeHandler, endpointHandler) => {
    const entityType = entityTypeHandler(reqUrl);
    const endpointArr = endpointHandler(entityType);
    const slug = getSlug(reqUrl);

    if (!canUseDom()) {
        console.log('getApiRequest', 'entityType', entityType);
        console.log('getApiRequest', 'endpointArr', getJsonStr(endpointArr));
    }

    // Calulate the `apiUrl` for each endpoit
    const requestEndpoints = endpointArr.map((tempEndpoint) => {
        // `enpointArr[?].enpoint` can be `string | function`
        if (typeof tempEndpoint.endPoint === 'function') {
            let apiUrl = '';
            if (tempEndpoint.endPoint === ENDPOINTS.PAGES) {
                apiUrl = tempEndpoint.endPoint(slug, getParent(reqUrl));
            } else {
                apiUrl = tempEndpoint.endPoint(slug);
            }

            console.log('apiUrl', 'apiUrl', apiUrl);

            return Object.assign({}, tempEndpoint, { apiUrl: apiUrl });
        }

        return Object.assign({}, tempEndpoint, { apiUrl: tempEndpoint.endPoint });
    });

    return requestEndpoints;
};

export const getApiRequestArr = (reqUrl) => {
    return getApiRequest(reqUrl, getEntityType, getEndpointArrByEntity);
};
